<template>
  <div class="row">
    <div class="col-md-8 col-sm-12 pb-4">
      <breadcrumb :page="page" />
    </div>
    <div
      v-if="hasPermission"
      class="col-md-4 col-sm-12 py-4 pr-0 text-right mb-3"
    >
      <router-link to="/pei/affirmativeletterhistoryadd">
        <ActionButton variant="success" i="fas fa-file-plus">
          Añadir
        </ActionButton>
      </router-link>
    </div>
    <div class="col-12 pr-0">
      <div class="dropdown-divider mt-0 pb-2 w-100 mt-n4 mb-4" />
      <div class="tab-content">
        <div class="main-content">
          <SectionTitle content="Búsqueda" :has-line="true" />

          <div class="row form-inline">
            <div class="pl-4 py-3 pb-4 pr-3">
              <b>Año Académico</b>
            </div>
            <div class="col-md-3 ml-2 py-3">
              <CustomDropDown
                v-model="currentAcademicYearsSelected"
                label
                placeholder="Seleccione"
                required
                fieldkey="id"
                fieldname="description"
                :options="currentAcademicYearsList"
              />
            </div>
            <div class="col-md-6 py-3">
              <ActionButton
                min-width="100px"
                variant="success"
                type="button"
                @click="initRows"
              >
                Buscar
              </ActionButton>
            </div>
          </div>

          <SectionTitle content="Resultados" :has-line="true" />

          <div class="row mb-4">
            <div class="col-12">
              <div class="row mx-0 header thead-property h-100 mh-100 py-3">
                <div class="col-md-2 col-sm-12">
                  <span>Año Académico</span>
                </div>
                <div class="col-md-6 col-sm-12">
                  <span>Servicios Carta Afirmativa</span>
                </div>
                <div class="col-md-2 col-sm-12">
                  <span>Estatus</span>
                </div>
                <div class="col-md-2 col-sm-12 pl-3 pl-md-5 pl-sm-5">
                  <span>Acción</span>
                </div>
              </div>
            </div>
          </div>

          <div
            v-for="(item, index) in items"
            :key="`item-row-${index}`"
            class="mb-3"
          >
            <div class="subheader tsubhead-property">
              <div class="row mb-2">
                <div class="col-md-2">
                  {{ item.academicYears }}
                </div>
                <div class="col-md-6">
                  <div v-html="item.services" />
                </div>
                <div class="col-md-2">
                  {{ item.status }}
                </div>
                <div class="col-md-2 pr-5 pb-3">
                  <button
                    class="btn btn-dropdown-actions dropdown-toggle pt-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Acciones
                  </button>
                  <div class="dropdown-menu dropdown-menu-right pb-0">
                    <a
                      class="drop-item cursor-pointer"
                      @click="onViewDetails(item)"
                    >
                      <i class="fas fa-file-search text-green pr-1" />
                      <span>Ver Detalle</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import { SectionTitle } from '@/components/pei/shared';
import CustomDropDown from '@/components/common/CustomDropDown';
import ActionButton from '@/components/common/ActionButton';
import store from '@/store/index';
import peiAffirmativeLetterStatuses from '@/utils/constants/pei/peiAffirmativeLetterStatuses';

export default {
  name: 'SearchHistory',
  components: {
    breadcrumb,
    SectionTitle,
    CustomDropDown,
    ActionButton,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-file-alt',
        title: 'Historial de Carta Afirmativa',
        routes: ['Inicio', 'PEI', 'Historial de Carta Afirmativa'],
      },
      apiUrl: '/api/affirmativeletters',
      currentAcademicYearsSelected: null,
      currentAcademicYearsList: [],
      historyAcademicYearsList: [],
      table: {
        emptyMessage: 'No se encontraron Cartas Afirmativas en Sistema',
        rows: [],
        columns: [
          {
            label: 'Año Académico',
            field: 'academicYears',
            thClass: 'text-center thVerticalMiddle',
            tdClass: 'text-center',
            width: '200px',
          },
          {
            label: 'Servicios Carta Afirmativa',
            field: 'services',
            html: true,
          },
          {
            label: 'Estatus',
            field: 'status',
            thClass: 'text-center thVerticalMiddle',
            tdClass: 'text-center',
            width: '100px',
          },
          {
            label: 'Acción',
            field: 'actions',
            thClass: 'text-center thVerticalMiddle',
            tdClass: 'text-center',
            width: '100px',
            title: 'Acciones',
          },
        ],
        pagingEnabled: false,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 10,
        count: 0,
      },
    };
  },
  methods: {
    getAllCurrentAcademicYears() {
      let self = this;

      return new Promise((resolve) => {
        self
          .$ApiGet(`${this.apiUrl}/currentacademicyear`)
          .then((res) => {
            self.currentAcademicYearsList = res.data;

            return resolve(res.data);
          })
          .catch((err) => (self.response = err));
      });
    },
    getAllHistoryByAcademicYears() {
      let self = this;

      return new Promise((resolve) => {
        self
          .$ApiGet(
            `${this.apiUrl}/allacademicyears?academicYearId=${
              this.currentAcademicYearsSelected
                ? this.currentAcademicYearsSelected.id
                : ''
            }`
          )
          .then((res) => {
            self.historyAcademicYearsList = res.data;

            return resolve(res.data);
          })
          .catch((err) => (self.response = err));
      });
    },
    async initRows() {
      await this.getAllHistoryByAcademicYears();

      let data = Array.from(this.historyAcademicYearsList),
        currentPage = [];

      if (data) {
        let dataTemp = [],
          i = 0;

        for (let item of data) {
          let servicesTemp = '';
          let services = item.services.split(',');

          for (let i = 0; i < services.length; i++) {
            servicesTemp += services[i] + '<BR>';
          }
          dataTemp.push({
            academicYears: item.academicYears,
            services: servicesTemp,
            status: item.status,
            actions: [
              {
                Icon: 'fas fa-file-search text-green',
                Text: 'Ver Detalle',
                Url:
                  item.status === peiAffirmativeLetterStatuses.Sometido
                    ? `/pei/affirmativeletterhistoryview/${item.peiAffirmativeLetterId}`
                    : `/pei/affirmativeletterhistoryedit/${item.peiAffirmativeLetterId}`,
              },
            ],
          });
        }

        this.table.rows = [];

        do {
          if (currentPage.length < 9) {
            currentPage.push(dataTemp[i]);
          } else {
            currentPage.push(dataTemp[i]);
            this.table.rows.push(currentPage);
            currentPage = [];
          }

          i++;

          if (!(i < dataTemp.length)) {
            this.table.rows.push(currentPage);
          }
        } while (i < dataTemp.length);

        this.table.totalItemCount = dataTemp.length;
      } else {
        this.table.rows.push(currentPage);
      }
    },
    goToPage(pageNumber) {
      if (
        this.table.currentPage != pageNumber &&
        pageNumber > 0 &&
        pageNumber <= this.table.rows.length
      ) {
        this.table.currentPage = pageNumber;
      }
    },
    onViewDetails(item) {
      this.$router.push({
        path: item.actions[0].Url,
      });
    },
  },
  computed: {
    items() {
      return this.table.rows ? this.table.rows[this.table.currentPage - 1] : [];
    },
    pages() {
      const pages = [];

      if (this.table.rows) {
        for (let i = 0; i < this.table.rows.length; i++) {
          pages.push(i + 1);
        }
      }

      return pages;
    },
    total() {
      return this.table.totalItemCount;
    },
    startIndex() {
      let startIndex = (this.table.currentPage - 1) * 10 + 1;

      return startIndex;
    },
    endIndex() {
      let endIndex = this.table.currentPage * 10;

      if (
        (this.table.currentPage + 1) * 10 > this.table.totalItemCount &&
        this.table.currentPage != 1
      ) {
        endIndex = this.table.totalItemCount;
      }

      return endIndex;
    },
    hasPermission() {
      return store.getters.HasPermission('affirmativeletter.modify');
    },
  },
  async mounted() {
    await this.getAllCurrentAcademicYears();
    await this.initRows();
  },
  destroyed() {
    this.$store.commit('$_student/showStudentBox', true);
  },
};
</script>

<style scoped>
.pagination-info {
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}
.pagination {
  font: Bold 14px/17px Lato;
}
.pagination > li > a {
  width: 33px;
  height: 34px;
  position: relative;
  float: left;
  text-align: center;
  line-height: 34px;

  letter-spacing: 0;
  color: #11291b;
  text-decoration: none;
}
.pagination > ul > li {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 6px;
}

.pagination > li a.active {
  background: #2db782 0% 0% no-repeat padding-box;
  color: white;
  border-radius: 6px;
}
.footer-show {
  font: 1rem 'Lato';
}

.main-content {
  margin: 0px;
  padding: 0px;
}

.btn.btn-green.success:hover {
  background: #2db782;
  color: #212529;
  text-decoration: none;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-item {
  font: 16px/18px Lato;
}

@media (min-width: 992px) {
  .btn-dropdown-actions {
    width: 4.5rem;
    font-size: 0.7rem;
    margin-right: 0px;
  }
}

@media (min-width: 1200px) and (max-width: 1440px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 6rem;
    margin-right: -8px;
  }
}

@media (min-width: 1440px) and (max-width: 1920px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 7.4375rem;
  }
}

/* BADGES */
.badges {
  color: black;
  font-size: 16px;
  width: 100%;
  height: 42px;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
}
.badge-erase {
  background: #fcc9c8;
}
.badge-cancel {
  background: #f4ceb3;
}
.badge-complete {
  background: #f8ea80;
}
.badge-signed {
  background: #a3e5b3;
}
.badge-incomplete {
  background: #f4ceb3;
}
.badge-waiting {
  background: #a7e6dc;
}
.badge-partial {
  background: #dee8b5;
}
.badge-pending-funds {
  background: #ddb3d7;
}
.badge-pending {
  background: #a7e6dc;
}

.header {
  height: 54px;
  padding-left: 20px;
  background: #3f5b60 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
  font-weight: bold;
}
.thead-property {
  color: #ffffff;
}
.subheader {
  padding-left: 20px;
  border-radius: 5px 5px 0px 0px;
  font-weight: bold;
  border-bottom: 1px solid #e0e2e9;
}
.tsubhead-property {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}
.btn-dropdown-actions {
  text-align: center;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
</style>
